export const SCHOOL_CALENDAR_STORE_NAME = 'SchoolCalendarStore';

export const SCHOOL_CALENDAR_BASE_API = 'holiday';

export const ACTIONS = {
  GET_OFFICIAL_HOLIDAYS: 'getOfficialHolidays',
  GET_WORKING_DAYS: 'getWorkingDays',
  GET_HOLIDAYS: 'getHolidays',
  GET_SCHOOLDAYS: 'getSchooldays',
  GET_SCHOOLDAYS_ACTIVE: 'getSchooldaysActive',
  GET_SCHOOLDAYS_LIST: 'getSchooldaysList',
  GET_COLORS_PREFERENCE: 'getColorsPreferences',
  SAVE_WORKING_DAYS: 'saveWorkingDays',
  SAVE_SCHOOLDAYS: 'saveSchooldays',
  SAVE_HOLIDAYS: 'saveHolidays',
  SAVE_COLORS_PREFERENCE: 'saveColorsPreferences',
  DELETE_HOLIDAYS: 'deleteHolidays',
  DELETE_SCHOOLDAYS: 'deleteSchooldays',
  GET_ORGANIZATION_SCHOOL_DAYS_LIST: 'getOrganizationSchooldaysList',
  GET_SCHOOLDAY_BY_ID: 'getSchooldayById'
}

export const MUTATIONS = {
  SET_HOLIDAYS:'setHolidays',
  SET_WORKING_DAYS:'setWorkingDays',
  SET_SCHOOLDAYS: 'setSchooldays',
  SET_SCHOOLDAYS_ACTIVE: 'setSchooldaysActive',
  SET_SCHOOLDAYS_LIST: 'setSchooldaysList',
  SET_PREFERENCES: 'setPreferences',
  UPDATE_COLOR: 'updateColor',
  UPDATE_SHOW_NON_SCHOOL_DAYS: 'updateShowNonSchoolDays',
  UPDATE_SCHOOL_DAY_COLOR: 'updateSchoolDayColor',
  SET_ORGANIZATION_SCHOOL_DAYS_LIST: 'setOrganizationSchooldaysList',
}

export const SCHOOL_CALENDAR_API = {
  GET_OFFICIAL_HOLIDAYS: 'holiday/official',
  GET_HOLIDAYS: 'holiday/plan/owner/{ownerType}/{ownerId}?year={year}&startDate={startDate}&endDate={endDate}',
  GET_WORKING_DAYS: 'holiday/workingDays',
  GET_SCHOOLDAYS: 'schoolday?organizationId={organizationId}&year={year}&startDate={startDate}&endDate={endDate}',
  GET_SCHOOLDAYS_ACTIVE: 'schoolday/active/current',
  GET_SCHOOLDAYS_LIST: 'schoolday/active/list',
  GET_COLORS_PREFERENCE: 'schoolday/color/preferences?organizationId={organizationId}',
  SAVE_WORKING_DAYS: 'holiday/workingDays',
  SAVE_SCHOOLDAYS: 'schoolday',
  SAVE_HOLIDAYS: 'holiday/plan',
  SAVE_COLORS_PREFERENCE: 'schoolday/color/preferences',
  DELETE_HOLIDAYS: 'holiday/plan',
  DELETE_SCHOOLDAYS: 'schoolday',
  GET_SCHOOL_CALENDAR_BY_ID: 'schoolday/{shooldayId}',
  GET_SCHOOL_CALENDAR_LIST: 'schoolday/{entityType}/{entityId}?endDate={endDate}&startDate={startDate}',
}

export const _SCHOOL_CALENDAR_STORE = {
  NAME: SCHOOL_CALENDAR_STORE_NAME,
  MUTATIONS: {
    SET_HOLIDAYS: `${SCHOOL_CALENDAR_STORE_NAME}/${MUTATIONS.SET_HOLIDAYS}`,
    SET_WORKING_DAYS: `${SCHOOL_CALENDAR_STORE_NAME}/${MUTATIONS.SET_WORKING_DAYS}`,
    UPDATE_SHOW_NON_SCHOOL_DAYS: `${SCHOOL_CALENDAR_STORE_NAME}/${MUTATIONS.UPDATE_SHOW_NON_SCHOOL_DAYS}`,
    SET_ORGANIZATION_SCHOOL_DAYS_LIST: `${SCHOOL_CALENDAR_STORE_NAME}/${MUTATIONS.SET_ORGANIZATION_SCHOOL_DAYS_LIST}`,
    SET_PREFERENCES: `${SCHOOL_CALENDAR_STORE_NAME}/${MUTATIONS.SET_PREFERENCES}`,
  },
  ACTIONS: {
    GET_OFFICIAL_HOLIDAYS: `${SCHOOL_CALENDAR_STORE_NAME}/${ACTIONS.GET_OFFICIAL_HOLIDAYS}`,
    GET_HOLIDAYS: `${SCHOOL_CALENDAR_STORE_NAME}/${ACTIONS.GET_HOLIDAYS}`,
    GET_WORKING_DAYS: `${SCHOOL_CALENDAR_STORE_NAME}/${ACTIONS.GET_WORKING_DAYS}`,
    GET_SCHOOLDAYS: `${SCHOOL_CALENDAR_STORE_NAME}/${ACTIONS.GET_SCHOOLDAYS}`,
    GET_SCHOOLDAYS_ACTIVE: `${SCHOOL_CALENDAR_STORE_NAME}/${ACTIONS.GET_SCHOOLDAYS_ACTIVE}`,
    GET_SCHOOLDAYS_LIST: `${SCHOOL_CALENDAR_STORE_NAME}/${ACTIONS.GET_SCHOOLDAYS_LIST}`,
    GET_COLORS_PREFERENCE: `${SCHOOL_CALENDAR_STORE_NAME}/${ACTIONS.GET_COLORS_PREFERENCE}`,
    SAVE_WORKING_DAYS: `${SCHOOL_CALENDAR_STORE_NAME}/${ACTIONS.SAVE_WORKING_DAYS}`,
    SAVE_SCHOOLDAYS: `${SCHOOL_CALENDAR_STORE_NAME}/${ACTIONS.SAVE_SCHOOLDAYS}`,
    SAVE_HOLIDAYS: `${SCHOOL_CALENDAR_STORE_NAME}/${ACTIONS.SAVE_HOLIDAYS}`,
    SAVE_COLORS_PREFERENCE: `${SCHOOL_CALENDAR_STORE_NAME}/${ACTIONS.SAVE_COLORS_PREFERENCE}`,
    DELETE_HOLIDAYS: `${SCHOOL_CALENDAR_STORE_NAME}/${ACTIONS.DELETE_HOLIDAYS}`,
    DELETE_SCHOOLDAYS: `${SCHOOL_CALENDAR_STORE_NAME}/${ACTIONS.DELETE_SCHOOLDAYS}`,
    GET_ORGANIZATION_SCHOOL_DAYS_LIST: `${SCHOOL_CALENDAR_STORE_NAME}/${ACTIONS.GET_ORGANIZATION_SCHOOL_DAYS_LIST}`,
    GET_SCHOOLDAY_BY_ID: `${SCHOOL_CALENDAR_STORE_NAME}/${ACTIONS.GET_SCHOOLDAY_BY_ID}`
  }
}

export const SCHOOL_DAYS_CALENDAR_COLORS = {
  SCHOOL_DAYS: ['#1E88E5', '#82B1FF', '#01579B', '#3bc7fd', '#1b84ad', '#00adff'],
  CURRENT_DATE: ['#2BB2AC'],
  HOLIDAYS: ['#FB3640', '#FFBB00'],
  OFF_DAY: ['#696969']
}

export const SCHOOL_DAY_STATUS = {
  OBSERVED: 'OBSERVED',
  IGNORED: 'IGNORED',
  NOTIFIED: 'NOTIFIED',
}

export const COLOR_PICKER_VALUES = {
  DEFAULT_COLOR: '#000000'
}

export const SCHOOL_DATE_TYPE = {
  DAY_OFF: 'DAY_OFF',
  SCHOOL_CALENDAR: 'SCHOOL_CALENDAR',
  FIRST_SCHOOL_CALENDAR: 'FIRST_SCHOOL_CALENDAR',
  LAST_SCHOOL_CALENDAR: 'LAST_SCHOOL_CALENDAR',
  US_HOLIDAYS: 'US_HOLIDAYS',
  CURRENT_DATE: 'CURRENT_DATE',
  EVENTS: 'EVENTS',
}

export const SCHOOL_DATE_TYPE_EVENT_CLASSES = {
  DAY_OFF: 'event-day-off',
  FIRST_SCHOOL_CALENDAR: 'event-first-school-calendar',
  LAST_SCHOOL_CALENDAR: 'event-last-school-calendar',
  US_HOLIDAYS: 'event-us-holidays',
  EVENTS: 'event-day-off',
  LESSON: 'event-lesson',
  LESSON_START: 'event-lesson-start',
  LESSON_PAST_DAY_START: 'event-lesson-past-day-start',
  LESSON_END: 'event-lesson-end',  
  LESSON_PAST_DAY_END: 'event-lesson-past-day-end',  
  LESSON_NON_SCHOOL_DAY: 'event-lesson-non-school-day',
  LESSON_PAST_DAY_NON_SCHOOL_DAY: 'event-lesson-past-day-non-school-day',
  LESSON_SCHOOL_DAY: 'event-lesson-school-day',
  LESSON_PAST_DAY: 'event-lesson-past-day',
  LESSON_FILLERS : 'event-fillers',
  LESSON_FUN : 'event-fun'
}

export const DATE_TYPES = {
  DAY_OFF: {
    label: 'offDay',
    value: SCHOOL_DAY_STATUS.OBSERVED
  },
  NON_SCHOOL_DAY: {
    label: 'event',
    value: SCHOOL_DAY_STATUS.NOTIFIED
  },
  BUSINESS: {
    label: 'schoolDay',
    value: SCHOOL_DAY_STATUS.IGNORED
  },
}

export const DATE_TYPES_OPTIONS = [{
  key: DATE_TYPES.BUSINESS.value,
  value: DATE_TYPES.BUSINESS.label
},{
  key: DATE_TYPES.DAY_OFF.value,
  value: DATE_TYPES.DAY_OFF.label
},{
  key: DATE_TYPES.NON_SCHOOL_DAY.value,
  value: DATE_TYPES.NON_SCHOOL_DAY.label
}]

export const SCHOOL_DAYS_EVENTS = {
  REFRESH_CALENDAR: 'REFRESH_CALENDAR'
}

export const HOLIDAY_CALENDAR_TYPE = {
  ORGANIZATION: 'ORG'
}
